import {
  CREATE_TERM_NEW_RECORD,
  CREATE_TERM_NEW_RECORD_SUCCESS,
  CREATE_TERM_NEW_RECORD_ERROR,  
  
  GET_TERM_NEW_RECORD,
  GET_TERM_NEW_RECORD_SUCCESS,
  GET_TERM_NEW_RECORD_ERROR,  

  SET_RECORD_TYPE,
  PANEL_NEW_RECORD_SHOW_HIDE_CLICK,
  PANEL_NEW_RECORD_HIDE_CLICK,
  UPDATE_NEW_RECORD_STATE,
} from "../actions";

export const getTermNewRecord = (termId, history) => ({
    type: GET_TERM_NEW_RECORD,
    payload: {termId, history}
  });

export const getTermNewRecordSuccess = (recordCreated) => ({
  type: GET_TERM_NEW_RECORD_SUCCESS,
  payload: recordCreated,
});

export const getTermNewRecordError = (message) => ({
  type: GET_TERM_NEW_RECORD_ERROR,
  payload: { message },
});

export const createTermNewRecord = (newRecord, history, activityInfo) => ({
    type: CREATE_TERM_NEW_RECORD,
    payload: {newRecord, history, activityInfo}
  });

export const createTermNewRecordSuccess = (recordCreated) => ({
  type: CREATE_TERM_NEW_RECORD_SUCCESS,
  payload: recordCreated,
});

export const createTermNewRecordError = (message) => ({
  type: CREATE_TERM_NEW_RECORD_ERROR,
  payload: { message },
});


export const hideNewRecordPanel = () => ({
    type: PANEL_NEW_RECORD_HIDE_CLICK,
    payload: {},
  });

export const toggleNewRecordPanel = () => ({
    type: PANEL_NEW_RECORD_SHOW_HIDE_CLICK,
    payload: {},
  });

export const setRecordType = (recordTypeSelected) => ({
    type: SET_RECORD_TYPE,
    payload: {recordTypeSelected},
  });

export const updateNewRecordState = (updatedValues) => ({
  type: UPDATE_NEW_RECORD_STATE,
  payload: { updatedValues }
});